import type { ClipboardEvent, KeyboardEvent } from "react";

const useKeysValidation = (): {
    handleKeyDownEvent: (event: KeyboardEvent<HTMLInputElement>, regex: string | RegExp) => void;
    handlePasteEvent: (event: ClipboardEvent<HTMLInputElement>, regex: string | RegExp) => void;
} => {
    const handleKeyDownEvent = (
        event: KeyboardEvent<HTMLInputElement>,
        regex: string | RegExp
    ): void => {
        const regExp = new RegExp(regex);
        const str = event.key;

        if (
            regExp.test(str) ||
            str === "Backspace" ||
            str === "ArrowLeft" ||
            str === "ArrowRight" ||
            str === "Delete" ||
            str === "Enter"
        ) {
            return;
        }

        event.preventDefault();
    };

    const handlePasteEvent = (
        event: ClipboardEvent<HTMLInputElement>,
        regex: string | RegExp
    ): void => {
        const regExp = new RegExp(regex);
        const str = event.clipboardData.getData("text");

        if (regExp.test(str)) {
            return;
        }

        event.preventDefault();
    };

    return {
        handleKeyDownEvent,
        handlePasteEvent,
    };
};

export default useKeysValidation;
